import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, IconButton, Progress } from "@chakra-ui/react";
import {
  FullBleedSection,
  MaxContentSection,
  BackNavArrowCta,
} from "~/components";
import { routes } from "~/constants";
import { XClose } from "~/icons";

interface Props {
  variant?: "back" | "close";
}

export const DiagnosticsNav: FC<Props> = ({ variant = undefined }) => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (variant === "close") {
      navigate(routes.diagnosticsDashboard);
    } else {
      navigate("/fertility-planning");
    }
  };

  return (
    <FullBleedSection bg="th.cream1" w="full">
      <MaxContentSection
        align="center"
        h={{ base: "3.625rem", md: 22 }}
        justify="center"
        maxW="160rem"
        overflow="hidden"
        position="relative"
        w="full"
      >
        <Flex
          align="center"
          justify="flex-start"
          left={{ base: 0, md: "1rem" }}
          position="absolute"
          w="full"
        >
          {variant === "close" && (
            <IconButton
              aria-label="Close and go to dashboard"
              icon={<XClose />}
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minW={{ base: "2.75rem", md: "3.5rem" }}
              h={{ base: "2.75rem", md: "3.5rem" }}
              color="fg-main"
              _hover={{ color: "fg-main-hover" }}
              onClick={handleNavigation}
            />
          )}
          {variant === "back" && (
            <BackNavArrowCta handleClick={handleNavigation} />
          )}
        </Flex>
      </MaxContentSection>

      {/* Progress bar - empty since it's just one step */}
      <MaxContentSection maxW="160rem" px={0}>
        <Progress
          bg="th.cream2"
          borderRadius="none"
          color="th.blueGreen2"
          h={2}
          value={0}
        />
      </MaxContentSection>
    </FullBleedSection>
  );
};
